import React, { Component } from 'react';

class Tuto extends Component {

  render() {
    return (
      <div className="card">

        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="alc-staff-inner post__meta-block posts__item--card posts__item">
                <header className="alc-staff__header">
                  <h1 className="page-heading__title">
                    <span className="alc-staff__header-last-name">
                      Tutorial for Westend
                    </span>
                  </h1>
                  <span className="alc-staff__header-role">
                    <h5 className="alc-staff__header-role-item">
                      Learn how to use this app
                    </h5>
                  </span>
                </header>
                <ul className="col-12 team-info-list list-unstyled">
                  <li className="team-info__value">1- Download <a target="_blank" href="https://polkadot.js.org/extension/">Polkadot.js extension</a> and install it</li>
                  <li className="team-info__value">2- Get Westend metadatas for your extension <a target="_blank" href="https://polkadot.js.org/apps/?rpc=wss%3A%2F%2Fwestend-rpc.polkadot.io#/settings/metadata">here</a> (metadata &gt; update metadata &gt; confirm)</li>
                  <li className="team-info__value">3- Create a new address (or several) within the extension</li>
                  <li className="team-info__value">4- Get some WND currency from the faucet by posting "!drip yourAddress" in <a target="_blank" href="https://app.element.io/#/room/#westend_faucet:matrix.org">this discussion</a></li>
                  <li className="team-info__value">5- Have fun minting your NFTs!</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Tuto;